/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invoice_Misa_Template_SummaryInputs */

const vi_invoice_misa_template_summary = /** @type {(inputs: Invoice_Misa_Template_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mẫu dùng cho hóa đơn điện tử`)
};

/**

* @param {Invoice_Misa_Template_SummaryInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const invoice_misa_template_summary = /** @type {((inputs?: Invoice_Misa_Template_SummaryInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invoice_Misa_Template_SummaryInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_invoice_misa_template_summary(inputs)
});